var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('img',{staticClass:"error-icon",attrs:{"src":require("@img/error.png")}}),_c('p',{staticClass:"error-info"},[_vm._v(_vm._s(_vm.info))])])
}
var staticRenderFns = []

export { render, staticRenderFns }